import { getDebugLogger, getInfoLogger, normalizeSlashChars } from '@ori/checkout-utils';
import { parseClientAppConfig } from '@ori/client-app-config';

import { APP_NAME } from '../constants';
import type { ClientAppConfig } from '../types';

const logDebug = getDebugLogger(APP_NAME);
const logInfo = getInfoLogger(APP_NAME);

/**
 * Normalizes some values in the raw parsed config.
 * @param parsedConfig Original config data returned by the parseClientAppConfig method.
 * @returns Final normalized configuration.
 */
export const normalizeConfigData = (parsedConfig: ClientAppConfig) => {
  const result: ClientAppConfig = {
    ...parsedConfig,
    useOpenedMinibagOnDesktop: Boolean(parsedConfig.useOpenedMinibagOnDesktop),
    staticApiUrl: normalizeSlashChars(parsedConfig.staticApiUrl, false, false),
  };
  logInfo('normalized configuration', result);

  return result;
};

/**
 * Parses the configuration.
 * @param config Config data serialized in a string in JSON format.
 * Usually taken from data-config HTML attribute of the component's root element.
 * @returns Normalized component configuration.
 */
export const getConfiguration = (config: string) => {
  const parsedConfig = parseClientAppConfig<ClientAppConfig>(config, ['currentLanguage', 'staticApiUrl', 'tenant']);
  logDebug('parsed configuration', parsedConfig);

  return parsedConfig;
};
